import { tryParseInt, checkEmailFormat } from "../../utils";
import { throwInfo } from "../../lib/error_helper";
import { setHeader, getParticipantType } from "./analyseRisquesActions";
import { isPPS } from "./analyseRisquesStatusActions";
import moment from "moment";
import db from "../../db";

export function checkIntegrity(analyseRisquesState, riskTypes) {
    if (
        (!analyseRisquesState.header.affair ||
            (analyseRisquesState.header.affair && !analyseRisquesState.header.affair.id)) &&
        !analyseRisquesState.header.affairInput &&
        !analyseRisquesState.header.numOt
    )
        throw new Error("L'affaire n'a pas été renseignée. Veuillez renseigner un numéro d'OT ou un numéro d'affaire");

    if (!analyseRisquesState.header.contact && !analyseRisquesState.header.customer_contact_tablet)
        throw new Error("Le contact n'a pas été renseigné");

    /*analyseRisquesState.header.delivery_address
    analyseRisquesState.header.status*/

    if (isPPS(analyseRisquesState.header.status)) {
        if (!analyseRisquesState.header.icpParticipants) throw new Error("Le champ participants doit-être renseigné");

        if (!moment(new Date(analyseRisquesState.header.jointInspectionDate)).isValid())
            throw new Error("La date d'inspection commune préalable n'est pas valide");

        if (!analyseRisquesState.header.jointInspectionDate)
            throw new Error("La date d'inspection jointe doit-être renseignée");
    }
    /*
        analyseRisquesState.header.communicatedInformation
        analyseRisquesState.header.icpParticipants
    */

    //Security
    if (isPPS(analyseRisquesState.header.status)) {
        if (analyseRisquesState.header.ppe.length <= 0) throw new Error("Veuillez renseigner au moins un EPI");
    }

    /*
        analyseRisquesState.header.necessaryEquipments
        analyseRisquesState.header.availableEquipments
        analyseRisquesState.header.specificsEquipments
        analyseRisquesState.header.instructions
        analyseRisquesState.header.additionnalInformations
        analyseRisquesState.header.place
        analyseRisquesState.header.equipment
        analyseRisquesState.header.accreditations
        analyseRisquesState.header.additionnalInformationAccreditations

    //Works nature
        analyseRisquesState.header.emergencyNumber
    */
    if (isPPS(analyseRisquesState.header.status)) {
        if (!analyseRisquesState.header.morningScheduleStart || !analyseRisquesState.header.morningScheduleEnd)
            throw new Error("Les horaires du matin ne sont pas correctements renseignés");

        if (!analyseRisquesState.header.afternoonScheduleStart || !analyseRisquesState.header.afternoonScheduleEnd)
            throw new Error("Les horaires due l'après midi ne sont pas correctements renseignés");

        if (!analyseRisquesState.header.duration) throw new Error("La durée doit-être renseignée");

        if (!moment(new Date(analyseRisquesState.header.expectedEndDate)))
            throw new Error("La date de fin expectée doit-être renseignée");

        if (!moment(new Date(analyseRisquesState.header.startDate)))
            throw new Error("La date de début doit-être renseignée");
    }

    if (!analyseRisquesState.header.natureAndLocation)
        throw new Error('Veuillez renseigner le champ "Nature et localisation"');

    if (!moment(new Date(analyseRisquesState.header.startDate)).isValid())
        throw new Error("La date de début des travaux n'est pas valide");

    if (!moment(new Date(analyseRisquesState.header.expectedEndDate)).isValid())
        throw new Error("La date de fin prévue n'est pas valide");

    if (
        moment(new Date(analyseRisquesState.header.expectedEndDate)) <
        moment(new Date(analyseRisquesState.header.startDate))
    )
        throw new Error("La date de fin prévue ne peut-être antérieure à la date de début");

    if (!analyseRisquesState.header.localeAgency) throw new Error("L'agence locale doit-être renseignée");

    if (analyseRisquesState.header.morningScheduleStart > analyseRisquesState.header.morningScheduleEnd)
        throw new Error("Le début de l'horaire du matin doit être inférieur à la fin de l'horaire du matin");

    if (analyseRisquesState.header.afternoonScheduleStart > analyseRisquesState.header.afternoonScheduleEnd)
        throw new Error(
            "Le début de l'horaire de l'après midi doit être inférieur à la fin de l'horaire de l'après midi"
        );

    if (analyseRisquesState.header.morningScheduleEnd > analyseRisquesState.header.afternoonScheduleStart)
        throw new Error("La fin de l'horaire du matin doit être inférieur au début de l'horaire de l'après midi");

    if (!analyseRisquesState.header.plannedOperationsDetails)
        throw new Error('Veuillez renseigner le champs "Détails d\'opérations plannifiées"');

    if (isPPS(analyseRisquesState.header.status)) {
        checkIntegrityOfParticipants(analyseRisquesState.participants);
        checkIntegrityOfCompanies(analyseRisquesState.sppCompanies, "PPS");
    } else {
        checkIntegrityOfCompanies(analyseRisquesState.raCompanies, "RA");
    }

    checkIntegrityOfRisks(analyseRisquesState.risks, riskTypes);
}

function checkIntegrityOfRisks(risks) {
    if (risks.filter((r) => r.id !== 0).length <= 0) throw new Error("Veuillez renseigner au moins un risque");

    risks
        .filter((r) => r.id !== 0)
        .forEach((r) => {
            if (!r.riskTypeId)
                throw new Error("[Risque " + r.id + "] Veuillez renseigner un type de risque pour chaque risque");

            if (r.solutions.filter((s) => s.id !== 0 && !s.deleted).length <= 0)
                throw new Error("[Risque " + r.id + "] Veuillez renseigner une solution pour chaque risque saisi");

            checkIntegrityOfMeasures(r.solutions);
        });
}

function checkIntegrityOfMeasures(measures) {
    measures.forEach((m) => {
        if (m.id === 0) return;

        if (!m.solutionTypeId) throw new Error("Veuillez renseigner un type de mesure pour chaque mesure");

        if (m.concernedCompanies.filter((cc) => !cc.deleted).length === 0)
            throw new Error("Veuillez sélectionner les intervenants pour chaque mesures saisies");

        if (m.commentRequired && !m.comment) throw new Error("Veuillez renseigner un commentaire pour chaque mesure");
    });
}

function checkIntegrityOfCompanies(companies, type) {
    companies
        .filter((c) => c.concerned)
        .forEach((c) => {
            if (!c.name && type === "PPS")
                throw new Error("Veuillez renseigner les noms de chaque intervenants (Onglet signatures)");

            if ((!c.email || !checkEmailFormat(c.email)) && type === "PPS")
                throw new Error(
                    "Veuillez renseigner des adresses mails valides pour chaque intervenants (Onglet signatures)"
                );

            if (!c.signature && type === "PPS") throw new Error("Signature manquante pour: " + c.name);
        });
}

function checkIntegrityOfParticipants(participants) {
    participants.forEach((p) => {
        let name;

        if (p.supplier) name = p.supplier.label;
        else if (p.tabletSupplierRef) name = p.tabletSupplierRef;
        else name = getParticipantType(p.typeId).name;

        let interimaires = tryParseInt(p.numberOfInterimaires.toString());
        let participantsNb = tryParseInt(p.numberOfParticipants.toString());

        if (!p.concerned && !p.works && !participantsNb && !p.supplier) return;

        if (p.customer) return;

        if (!p.works)
            throw new Error('Veuillez vérifier que le champs "travaux" du participant ' + name + " est renseigné");

        if (!p.typeId)
            throw new Error(
                "Tous les participants doivent avoir un type renseigné. Contactez l'administrateur de l'application"
            );

        if (p.canChangeName && !p.supplier)
            throw new Error("Veuillez vérifier que le participant " + name + " a un sous traitant renseigné");

        if (!interimaires && interimaires !== 0)
            throw new Error("Le champs nombre d'intérimaires doit être un nombre entier pour le participant " + name);

        if (!p.supplier && participantsNb <= 0)
            throw new Error("Le champ nombre de participants doit être supérieur à 0 pour le participant " + name);

        if (interimaires > participantsNb)
            throw new Error(
                "Le nombre d'intérimaires ne peut être supérieur au nombre de participants pour le participant " + name
            );
    });
}

export function checkBeforeSubmit(header) {
    return (dispatch) => {
        header.checkBeforeSubmit = true;
        dispatch(setHeader(header));
        dispatch(
            throwInfo({
                title: "Information",
                message: "Veuillez vérifier que les informations saisies sont correctes",
                dismissible: true,
            })
        );
    };
}

export function cancelCheckBeforeSubmit(header) {
    return (dispatch) => {
        header.checkBeforeSubmit = false;
        dispatch(setHeader(header));
    };
}

export function checkSppAlreadyExists(arId) {
    return db.Pps.toArray().then(async (pps) => {
        let ids = pps.map((pps) => pps.id);

        let alreadyExist = false;

        ids.forEach((id) => {
            if (id === arId) alreadyExist = true;
        });

        return alreadyExist;
    });
}
